let cancelActionMixin = {
    methods: {
        cancelAction (message) {
            return this.$swal({
                type: 'warning',
                title: 'Are you sure?',
                text: `Unsaved changes will be lost.`,
                showCancelButton: true,
                confirmButtonText: 'YES',
                cancelButtonText: 'No, I have changes to save',
            }).then((result) => {
                if (result.value) {
                    this.$bus.$emit('bb:closeModal');
                    this.$emit('closeModal');
                }
            });
        }
    }
};
    
export default cancelActionMixin;
